export interface S3DocSelection {
	bucket: string;
	documentId: number;
	fileType: string;
	key: string;
	name: string;
}

/** Sent alongside messages in the POST body for server-side Anthropic Files API upload. */
export interface S3DocRef {
	bucket: string;
	documentId: number;
	fileType: string;
	key: string;
	name: string;
}

// Marker helpers and the S3DocMeta type live in a shared util so the server-side
// chat code (route.ts, threads/[threadId].ts, s3Documents.ts) and the client
// components can use the same parser and stay in lockstep on format changes.
export { buildS3DocMetaMarker, parseS3DocMetaMarkers, stripS3DocMetaMarkers } from '~/utils/s3DocMarker';
export type { S3DocMeta } from '~/utils/s3DocMarker';
